// DO NOT EDIT -- generated from fs/services/emissary/integration_access_flags.proto

export enum IntegrationAccessFlag {
  INTEGRATION_ACCESS_UNKNOWN = 0,
  INTEGRATION_ACCESS_CONNECT = 1,
  INTEGRATION_ACCESS_UPDATE_CONNECTION = 2,
  INTEGRATION_ACCESS_DISCONNECT = 3,
  INTEGRATION_ACCESS_VIEW_CONFIG_DETAILS = 4,
  INTEGRATION_ACCESS_USE_CONFIG = 5,
  INTEGRATION_ACCESS_UPDATE_CONFIG = 6,
  INTEGRATION_ACCESS_DELETE_CONFIG = 7,
  INTEGRATION_ACCESS_VIEW_VALIDATION_ERRORS = 8
}
